import React, { Component, createRef } from "react";
import { Button, Alert } from "react-bootstrap";

import "./ChiasseTestingFacility.css";

class ChiasseTestingFacility extends Component {
	constructor(props) {
		super(props);
		this.ButtonRef = createRef();

		this.state = {
			CacaMiel: 1,
			Visible: false,
		};
	}

	CacaMielPressed() {
		this.setState({ CacaMiel: this.state.CacaMiel + 1 });
		console.log(this.ButtonRef);
		if (this.state.CacaMiel == 5 - 1) {
			this.ButtonRef.current.disabled = true;
			this.setState({ Visible: true });
		}
	}
	FuckUPressed() {
		this.ButtonRef.current.disabled = false;
		this.setState({ Visible: false });
	}

	render() {
		return (
			<>
				{this.state.CacaMiel == 5 && (
					<Alert variant="danger">
						Oh non! <b>CacaMiel</b> est devenu trop puissant!
					</Alert>
				)}

				<p>CacaMiel = {this.state.CacaMiel}</p>

				<div className="mb-2">
					<Button ref={this.ButtonRef} onClick={this.CacaMielPressed.bind(this)} variant="primary" size="lg">
						CacaMiel Button
					</Button>
					<br />
					<br />
					<Button className={this.state.Visible ? "" : "home-fuckubutton-visible"} onClick={this.FuckUPressed.bind(this)} visible={this.FuckURef} variant="danger" size="lg">
						{" "}
						Fuck it, all in
					</Button>
				</div>
			</>
		);
	}
}
export default ChiasseTestingFacility;
